/**
 * Converts an image from a URL to a base64 data URL string.
 * @param imageUrl - The URL of the image to convert.
 * @returns The base64 data URL string of the image.
 */
export async function convertImageUrlToBase64(imageUrl: string): Promise<string> {
  const response = await fetch(imageUrl);
  const blob = await response.blob();

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string);
    };

    reader.addEventListener("error", reject);
    reader.readAsDataURL(blob);
  });
}
